import { FC } from 'react';
import { HelpOutline } from '@mui/icons-material';
import {
  Typography,
  Tooltip,
  tooltipClasses,
  TooltipProps,
  styled,
} from '@mui/material';

// tooltip doesnt seem to like in-line styling so must use the styled() function
const LightTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({}) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: 'white',
    color: 'black',
    pointerEvents: 'none', // prevents mobile flickering
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: 'white',
  },
}));

const ShapeTooltip: FC = () => {
  return (
    <LightTooltip
      arrow
      // mobile requires these two props
      enterTouchDelay={0}
      leaveTouchDelay={30000}
      title={
        <>
          <Typography
            variant='body1'
            fontWeight='bold'
            fontSize='12px'
            marginBottom='0.5rem'
          >
            Product Shape
          </Typography>
          <Typography variant='body1' fontSize='12px'>
            The Product Shape is a tool for product managers to evaluate their
            own talents and expertise across various areas. It is meant to aid
            in profressional development, helping product managers make more
            informed decisions about progressing their careers and enchancing
            their skills.
          </Typography>
        </>
      }
    >
      <HelpOutline
        style={{
          marginLeft: '1rem',
          verticalAlign: 'middle',
        }}
      />
    </LightTooltip>
  );
};

export default ShapeTooltip;
